import { API } from './api'

export interface Trace {
  id: string
  serialNo: string
  TraceEvent: string
  OrderNo: string
  ProductId: string
  TraceTime: string
  'Company Name'?: string | null
  Created: string
  UserLocation: string
  ReasonCode?: string | null
  SpecifiedReasonCode?: string | null
  CompanySupplyChainRole?: string
  ShipTo?: { Name: string } | string
}

export interface TraceApiResponse {
  Count: number
  ScannedCount: number
  Items: Trace[]
  LastEvaluatedKey?: { id: string }
}

export interface BatteryChangeApiResponse {
  serial: string
  message: string
}

export const fetchTracesByOrderNumber = (orderNumber: string, lastKey: string = ''): Promise<TraceApiResponse> => {
  const queryStringParameters: { searchParam: string; lastKey?: string } = { searchParam: orderNumber }
  if (lastKey) queryStringParameters.lastKey = lastKey
  return API.get('its', '/tracing/order', { queryStringParameters })
}

export const fetchAllTracesByOrderNumber = async (orderNumber: string, lastKey: string = ''): Promise<Trace[]> => {
  const traces = await fetchTracesByOrderNumber(orderNumber.toUpperCase(), lastKey)
  if (traces.LastEvaluatedKey) {
    return [...traces.Items, ...(await fetchAllTracesByOrderNumber(orderNumber, traces.LastEvaluatedKey.id))]
  }
  return traces.Items
}

export const createTraces = (traces: Trace[]): Promise<TraceApiResponse> => {
  return API.post('its', '/serial-handling', { body: { rows: traces }, response: true })
}

export const batteryChange = (myserialno: string): Promise<BatteryChangeApiResponse> => {
  return API.get('its', '/tracing/battery-change', { queryStringParameters: { searchParam: myserialno }})
}